import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { LOGIN, ONBORADING_SCREEN, SIGNUP } from '../../navigation/Constants';
import { setSignupData } from '../../redux/signup';
import { RootState } from '../../redux/store';
import FacebookLogin from '../Login/components/FacebookLogin';
import GoogleLogin from '../Login/components/GoogleLogin';
import LoginForm from '../Login/components/loginForm';
import { GAEventNames, GACategoryName, GAUniqueEventIds } from '../../helpers/Enums';
import { recordGaEvent } from '../../helpers/GoogleAnalytics';

function SignupMenu() {
    const history = useHistory();
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [hasAccptedNewsLatter, setHasAccptedNewsLatter] = useState<boolean>(true);

    const dispatch = useDispatch();
    const resgiter = useSelector((state: RootState) => state.signup);

    const startRegisration = () => {
        resgiter.acceptNewsletter = hasAccptedNewsLatter;
        dispatch(setSignupData(resgiter));
        history.push(SIGNUP);

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 1", "אישור תנאי שימוש", GAUniqueEventIds.APP_SIGNUP)

    }

    return (
        <>
            <div className="content_sec wf-section">
                <div className="login_top">
                    <Link to={ONBORADING_SCREEN} className="top_back login w-inline-block" >
                        <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
                    </Link>
                    <div className="login_logo" style={{ width: "200px" }}>
                        <img src="assets/images/shoshke_logo.svg" loading="lazy" alt="" />
                    </div>
                    {/* <div>
                        אם כבר נרשמת בעבר, יש להכניס כאן את המייל והסיסמה שלך. אם עוד לא נרשמת יש
                        ללחוץ על הכפתור ״רוצה להירשם״ בתחתית
                    </div> */}
                    <div>
                        <h2>עוד רגע ונתחיל להכיר</h2>
                        ההרשמה לקהילה ממש פשוטה!
                        <br />
                        <br />
                        אפשר לדלג על שלבים
                        <br />
                        ולשנות או לעדכן פרטים בהמשך
                    </div>
                    <br />
                </div>

                <div className="form_buttons_group check">
                    <label className="w-checkbox checkbox_field w-clearfix">
                        <div className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox ${isChecked ? 'w--redirected-checked' : ''}`} style={{ minWidth: '31px', height: '31px' }} />
                        <input autoComplete="off"
                            onChange={() => { setIsChecked(pre => !pre) }}
                            checked={isChecked}
                            type="checkbox"
                            id="checkbox"
                            name="checkbox"
                            data-name="Checkbox"
                            style={{ opacity: 0, position: "absolute", zIndex: -1 }}
                        />
                        <span className="checkbox_label w-form-label">נא לסמן שקראת ואישרת את <a target="blank" href='https://www.motke.co.il/%D7%AA%D7%A0%D7%90%D7%99-%D7%A9%D7%99%D7%9E%D7%95%D7%A9-%D7%A9%D7%95%D7%A9%D7%A7%D7%941'>תנאי השימוש </a> ואת<a target="blank" href='https://www.motke.co.il/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA-%D7%A9%D7%95%D7%A9%D7%A7%D7%94'> מדיניות הפרטיות</a></span>
                    </label>
                </div>

                <div className="form_buttons_group check">
                    <label className="w-checkbox checkbox_field w-clearfix" style={{ marginTop: "5px" }}>
                        <div className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox ${hasAccptedNewsLatter ? 'w--redirected-checked' : ''}`} style={{ width: '31px', height: '31px' }} />
                        <input
                            onChange={() => { setHasAccptedNewsLatter(pre => !pre) }}
                            checked={hasAccptedNewsLatter}
                            type="checkbox"
                            id="checkbox"
                            name="checkbox"
                            data-name="Checkbox"
                            style={{ opacity: 0, position: "absolute", zIndex: -1 }}
                        />
                        <span className="checkbox_label w-form-label">אשמח לקבל דיוור עם מידע והצעות מעניינות</span>
                    </label>
                </div>


                <div className="login_sec w-form login_social">
                    {/* <LoginForm /> */}
                    <input autoComplete="off"
                        type="submit"
                        value="להצטרפות"
                        data-wait
                        className={`button_full w-button ${!isChecked ? 'inactive ' : ''}`}
                        onClick={() => isChecked ? startRegisration() : null}
                        style={{ width: '100%' }}
                    />
                </div>
                <div className="login_social">
                    {/* <div>הצטרפות דרך גוגל או פייסבוק</div>
                    <div>(ההרשמה שלך לא תתפרסם ברשתות)</div>
                    <div className="form_buttons_group" style={{ display: 'flex', justifyContent: 'space-between' }}> */}
                    {/* <AppleLogin /> */}
                    {/* <GoogleLogin isChecked={isChecked} />
                        <FacebookLogin isChecked={isChecked} />
                    </div> */}
                    <div className="login_terms_use">
                        {/* <div className="terms_txt title">אל דאגה</div>
                        <div className="terms_txt">, הרשמתך לא תפורסם בפייסבוק</div> */}
                    </div>
                    <div className="login_terms_use">
                        <Link to={LOGIN}>
                            כניסה לחברים רשומים
                        </Link>
                        {/* <div className="terms_txt">הרשמתך מהווה הסכמה ל</div> */}
                        {/* <a href="#" className="terms_txt link">
                            תנאי השימוש והפרטיות
                        </a> */}
                    </div>
                </div>
            </div>

        </>
    )
}

export default SignupMenu;